import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CreateProductsWithInstallationsMutationVariables = Types.Exact<{
  input: Types.BatchCreateProductsWithInstalledProductsInput;
}>;


export type CreateProductsWithInstallationsMutation = { __typename?: 'mutation_root', batch_create_products_with_installed_products?: { __typename?: 'BatchCreateProductsWithInstalledProductsOutput', total_products: number, successful_products: number, failed_products: number, total_installed_products: number, successful_installed_products: number, failed_installed_products: number, results: Array<{ __typename?: 'ProductWithInstalledProductsResultOutput', success: boolean, product_id?: string | null, error?: string | null, index: number, installed_products_successful: number, installed_products_failed: number, created_product?: { __typename?: 'ProductsActionType', id: any, name: string, make: string, model: string, type: string, partition_id?: string | null } | null, installed_products_results: Array<{ __typename?: 'InstalledProductResultOutput', success: boolean, installed_product_id?: string | null, error?: string | null, index: number, created_installed_product?: { __typename?: 'installed_products_ActionType', id: any, product_serial?: string | null, location?: string | null, warranty_status: string, partition_id?: string | null } | null }> }> } | null };


export const CreateProductsWithInstallationsDocument = gql`
    mutation CreateProductsWithInstallations($input: BatchCreateProductsWithInstalledProductsInput!) {
  batch_create_products_with_installed_products(input: $input) {
    total_products
    successful_products
    failed_products
    total_installed_products
    successful_installed_products
    failed_installed_products
    results {
      success
      product_id
      error
      index
      created_product {
        id
        name
        make
        model
        type
        partition_id
      }
      installed_products_results {
        success
        installed_product_id
        error
        index
        created_installed_product {
          id
          product_serial
          location
          warranty_status
          partition_id
        }
      }
      installed_products_successful
      installed_products_failed
    }
  }
}
    `;
export type CreateProductsWithInstallationsMutationFn = Apollo.MutationFunction<CreateProductsWithInstallationsMutation, CreateProductsWithInstallationsMutationVariables>;

/**
 * __useCreateProductsWithInstallationsMutation__
 *
 * To run a mutation, you first call `useCreateProductsWithInstallationsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateProductsWithInstallationsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createProductsWithInstallationsMutation, { data, loading, error }] = useCreateProductsWithInstallationsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateProductsWithInstallationsMutation(baseOptions?: Apollo.MutationHookOptions<CreateProductsWithInstallationsMutation, CreateProductsWithInstallationsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateProductsWithInstallationsMutation, CreateProductsWithInstallationsMutationVariables>(CreateProductsWithInstallationsDocument, options);
      }
export type CreateProductsWithInstallationsMutationHookResult = ReturnType<typeof useCreateProductsWithInstallationsMutation>;
export type CreateProductsWithInstallationsMutationResult = Apollo.MutationResult<CreateProductsWithInstallationsMutation>;
export type CreateProductsWithInstallationsMutationOptions = Apollo.BaseMutationOptions<CreateProductsWithInstallationsMutation, CreateProductsWithInstallationsMutationVariables>;